<template>
    <div class="order-table">
        <el-table :data="tableData" v-loading="loading" border size="mini" :header-cell-style="headerCellStyle" :height="tableHeight" @selection-change="handleSelectionChange">
            <!-- <el-table-column type="selection" width="40" align="left" v-if="checkRole('cgy_role') && pageFlag == 'inquiry'"> </el-table-column> -->
            <el-table-column prop="orderCode" label="订单号">
                <template slot-scope="scope">
                    <router-link :to="{path:`/omgOrderDetail/${scope.row.id}`}">
                        {{scope.row.orderCode}}
                    </router-link>
                </template>
            </el-table-column>
            <el-table-column prop="xjOrderCode" label="询价单号"></el-table-column>
             <el-table-column prop="orderState" label="订单状态" :formatter="formatStatus"></el-table-column>
            <el-table-column prop="orderTime" label="订单日期" :show-overflow-tooltip="true"> </el-table-column>
            <el-table-column prop="cgyName" label="采购员" align="center" :show-overflow-tooltip="true"> </el-table-column>
            <el-table-column prop="customName" label="收货客户" align="center" :show-overflow-tooltip="true"> </el-table-column>
            <el-table-column label="操作" align="left" width="150px" fixed="right">
                <template slot-scope="scope">
                    <router-link :to="{path:`/omgOrderDetail/${scope.row.id}`}">订单详情</router-link>
                </template>
            </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" class="mg-t5">
            <pagination v-show="count>0" @on-pagination="onPagination" :page.sync="page"
                :limit.sync="limit" :total="count">
            </pagination>
        </el-row>
    </div>
</template>
<script>
    import { xjtypes } from'../../utils/dict'
    export default {
        name: 'OrderTable',
        props:['tableData','count','tableHeight','page','limit','pageFlag','currencyObj','loading'],
        data(){
            return {}
        },
        computed:{
            PAGESIZE:function(){
                return this.$store.getters['app/sizeInfo'];
            },
            userRoles:function(){
                return this.$store.getters['user/roles'];
            },
        },
        methods:{
            // 勾选
            handleSelectionChange(val) {
				let ids = [];
				for (let item of val) {
					ids.push(item.id);
                }
                this.$emit('callback',{type:'selecttable',info:ids})
            },
            // 表格操作
            tableHandle: function(row,type){
                this.$emit('callback',{type:type,info:row})
            },
            // 状态值转换
            formatStatus: function(row) {

                let stateObj = {};
                if(this.checkRole('cgy_role')){
                    // 待发布0  确认中1 已确认2 送货计划3 已签收4 已入库5 已开票6
                    stateObj = {
                        's_0':'待发布',
                        's_1':'确认中',
                        's_2':'已确认',
                        's_3':'送货计划',
                        's_4':'已签收',
                        's_5':'已入库',
                        's_6':'已开票',
                    }
                    return stateObj[`s_${row.state}`];
                }else if(this.checkRole('gys_role')){
                    // 待确认1 已确认2 送货计划3 已签收4 已入库5 已开票6
                    stateObj = {
                        's_1':'待确认',
                        's_2':'已确认',
                        's_3':'送货计划',
                        's_4':'已签收',
                        's_5':'已入库',
                        's_6':'已开票',
                    }
                    return stateObj[`s_${row.state}`];
                }


            },
            // 页码切换
            onPagination: function(val) {
                this.$emit('callback',{type:'pagination',info:val})
            },
            formatCurrency: function(row) {
				return this.currencyObj[row.currency];
            },
            formatXjtype:function(row){
                let str = '';
                xjtypes.forEach((item)=>{
                    if(item.code == row.xjFs){
                        str = item.name;
                    }
                });
                return str;
            },
        }
    }
</script>
<style lang="scss" scoped>
</style>
